// Libs
import { StyleSheet, Text, View } from '@react-pdf/renderer';
// Components, Layouts, Pages
// Others
import { DEFAULT_CURRENCY } from '~/utils/constants/common';
import { formatCurrency } from '~/utils/helper/common';
// Styles, images, icons

type Props = {
  total?: number;
  subtotal?: number;
  tax?: string;
};

const TotalPdf = (props: Props) => {
  //#region Destructuring Props
  const { total, subtotal, tax } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <View style={styles.container}>
      <View style={styles.total}>
        <Text style={styles.titleTotal}>Subtotal: </Text>

        <Text style={styles.valueTotal}>
          {subtotal ? formatCurrency(Number(subtotal)) : DEFAULT_CURRENCY}
        </Text>
      </View>
      <View style={styles.total}>
        <Text style={styles.titleTotal}>Tax: </Text>

        <Text style={styles.valueTax}>{`${tax} %`}</Text>
      </View>
      <View style={styles.total}>
        <Text style={styles.titleTotal}>Total: </Text>

        <Text style={styles.valueTotal}>{total ? formatCurrency(Number(total)) : DEFAULT_CURRENCY}</Text>
      </View>
    </View>
  );
};

export default TotalPdf;

export const styles = StyleSheet.create({
  container: {
    gap: 10,
  },
  total: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    marginRight: 8,
    width: 200,
    justifyContent: 'space-between',
  },
  titleTotal: {
    width: 100,
    textAlign: 'right',
    fontSize: 12,
    color: '#333333',
    fontWeight: 'bold',
  },
  valueTotal: {
    fontSize: 12,
    color: '#63667A',
  },
  valueTax: {
    fontSize: 12,
    color: '#FF4E3E',
  },
});
